// src/services/textConversionService.js
import api from "./api";

/**
 * Conversão de um texto de plano para HTML (Fase 4/5 da refatoração de conteúdo).
 *
 * ⚠️ Operação administrativa: o backend exige o papel `Sys` nos dois endpoints e
 * devolve 403 para qualquer outro. Esconder o botão na interface é conveniência,
 * não autorização.
 */

/**
 * Simula a conversão e devolve o relatório do que seria gravado. **Não escreve.**
 * É o que a tela mostra antes de pedir confirmação.
 */
export function dryRunConversion(textId) {
  return api.get(`/TextHtmlConversion/${textId}/dry-run`);
}

/**
 * Converte de verdade: reescreve o arquivo do texto e os offsets das notas.
 *
 * **Irreversível fora do backup**, cujo caminho volta na resposta. O backend refaz
 * o ensaio por dentro e recusa (400) se ele não estiver seguro — o relatório que o
 * usuário viu pode ter envelhecido entre a conferência e o clique.
 */
export function convertTextToHtml(textId) {
  return api.post(`/TextHtmlConversion/${textId}/convert`);
}
